<template>
    <div v-if="loan">
        <template v-if="loan && ! loan.round_sky_application && ! loan.leads_market_application">
            <!--
                Gated on `isFunded` (resources/js/constants/loanStatus.js, issue #4736).
                The not-funded branch must contain zero references to payments,
                interest, fee, balance, payback period, or loan term.
            -->
            <template v-if="! isFunded">
                <!-- TODO(#4736): confirm final copy with @seanmo0123 before merge. -->
                <div class="line">In progress</div>
                <div class="line">Continue your application</div>
            </template>
            <template v-else-if="! isLoanActive || loan.status === 'pay_in_full_posted' || remainingBalance === null || ! futurePayments.length">
                <div class="line">--</div>
                <div class="line">--</div>
                <div class="line">--</div>
                <div class="line">--</div>
            </template>
            <template v-else-if="loan.status === 'pay_in_full_processing'">
                <div class="line">1</div>
                <div class="line">{{ loan.pif_amount | money }}</div>
                <div class="line">{{ loan.full_payment_scheduled_at | date('MMM D') }}</div>
                <div class="line">Auto</div>
            </template>
            <template v-else>
                <div class="line">{{ futurePendingPayments.length }}</div>
                <div class="line">{{ futurePendingPayments[0].computed_amount | money }}</div>
                <div class="line">{{ futurePendingPayments[0].due_at | date('MMM D') }}</div>
                <div v-if="loan.payment_status == 'ach'" class="line">Auto</div>
                <div v-else>
                    <div>ACH revoked</div>
                    <div class="text-sm md:max-w-none max-w-[200px] md:break-normal break-words">
                        <a :href="`mailto:${supportEmail}`" class="md:break-normal break-all">{{ supportEmail }}</a>
                        <br>to schedule a payment
                    </div>
                </div>
            </template>
        </template>
    </div>
</template>

<style scoped>
    .line:not(:last-child) {
        margin-bottom: 0.75rem;
    }
</style>

<script>
export default {
    name: "LoanSummaryRight",
    mixins: [
        require('../mixins/InteractsWithLoans').default
    ],
    data() {
        return {
            supportEmail: window.support_email,
        }
    },
};
</script>